import * as React from 'react';

import { Button } from 'components/bootstrap';
import { SelectedRowsProvider, useSelectedRows } from 'common/contexts';
import { Modal, Row } from 'common/components';

import EventProceduresLilList from './List';

type Props = {
  onClose: () => void;
  onAdd: (selectedProcedure: string) => void;
};

const Buttons = ({ onClose, onAdd }: Props) => {
  const selectedRows = useSelectedRows();

  return (
    <Row $justify="flex-end" $align="center">
      <Button onClick={onClose}>Cancel</Button>
      <Button bsStyle="primary" disabled={selectedRows.length < 1} onClick={() => onAdd(selectedRows[0].id)}>
        Add Procedure
      </Button>
    </Row>
  );
};

function EventProcedureLibraryForm({ onClose, onAdd }: Props) {
  return (
    <SelectedRowsProvider>
      <Modal
        show
        onClose={onClose}
        maxWidth="1200px"
        title="Add Procedure from Library"
        buttons={<Buttons onClose={onClose} onAdd={onAdd} />}>
        <EventProceduresLilList />
      </Modal>
    </SelectedRowsProvider>
  );
}

export default EventProcedureLibraryForm;
